'use client'

import type React from 'react'
import { useContext } from 'react'
import styles from './CardSliderCard.module.css'
import { DragDistanceContext } from './CardSlider'

interface CardSliderCardProps {
    children: React.ReactNode
    isBlurVariant?: boolean
    /** Custom border radius in px. Overrides default 25px / 16px (blur). */
    radius?: number
}

export function CardSliderCard({ children, isBlurVariant = false, radius }: CardSliderCardProps) {
    const dragDistanceRef = useContext(DragDistanceContext)
    const cardClass = isBlurVariant ? styles.cardBackdrop : styles.cardDefault

    const handleClick = (e: React.MouseEvent) => {
        if (dragDistanceRef?.current && dragDistanceRef.current > 5) {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    return (
        <div
            className={`${styles.card} ${cardClass}`}
            style={{
                ...(radius !== undefined && { borderRadius: radius, overflow: 'hidden' }),
                ...(isBlurVariant && {
                    willChange: 'transform',
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden',
                }),
            }}
            onClick={handleClick}
            onClickCapture={handleClick}
        >
            {children}
        </div>
    )
}
